import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { getLimite } from '../../../../store/loan/thunks';

export const SimularContratar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dtParcelas, setDtParcelas] = useState({});
  const [dadosBancarios, setDadosBancarios] = useState({});

  useEffect(() => {
    dispatch(getLimite());
  }, [dispatch]);

  const nextState = (url, dtparcelas, dadosbancarios) => {
    setDtParcelas(dtparcelas);
    setDadosBancarios(dadosbancarios);
    navigate(url);
  };

  const previousState = (url) => {
    navigate(url);
  };

  return (
    <Outlet
      context={{
        onNext: nextState,
        onBack: previousState,
        dtParcelas,
        dadosBancarios,
      }}
    />
  );
};
